import { render, staticRenderFns } from "./HeaderPageLayout.vue?vue&type=template&id=36011cbb&"
import script from "./HeaderPageLayout.vue?vue&type=script&lang=js&"
export * from "./HeaderPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports